import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function WhyNothingElseWorkedSection() {
  const failures = [{
    title: 'Detox teas?',
    desc: 'Just bathroom panic.'
  }, {
    title: 'Dry brushing?',
    desc: 'A chore with no clear results.'
  }, {
    title: 'Expensive massages?',
    desc: 'Nice… but temporary.'
  }, {
    title: 'Extreme cleanses?',
    desc: 'Not sustainable.'
  }];
  return <section className="py-24 bg-white" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-268">
          {/* Visual Side - Frustration Collage */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative order-2 lg:order-1" data-id="element-269">
            <div className="grid grid-cols-2 gap-4" data-id="element-270">
              <img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&q=80&w=500" alt="Confusing supplements" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-271" />
              <img src="https://images.unsplash.com/photo-1519824145371-296894a0daa9?auto=format&fit=crop&q=80&w=500" alt="Exhausted woman" className="rounded-2xl shadow-lg w-full h-64 object-cover mt-8" data-id="element-272" />
            </div>
            {/* Floating Badge */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-red-500 text-white px-6 py-3 rounded-full font-bold shadow-xl whitespace-nowrap z-10" data-id="element-273">
              Stop the Cycle 🛑
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-274">
            <span className="text-gray-500 font-bold uppercase tracking-wider text-sm" data-id="element-275">
              WHY NOTHING ELSE WORKED
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mt-2 mb-4" data-id="element-276">
              Why Other "Solutions" Fail Long-Term
            </h2>
            <p className="text-xl text-[#374151] mb-12" data-id="element-277">
              Women have tried everything...
            </p>

            <div className="space-y-4 mb-12" data-id="element-278">
              {failures.map((fail, i) => <div key={i} className="bg-red-50 p-4 rounded-xl border border-red-100 flex items-center gap-4" data-id="element-279">
                  <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-280">
                    <X className="w-5 h-5 text-red-500" data-id="element-281" />
                  </div>
                  <div data-id="element-282">
                    <span className="font-bold text-[#1B5E20] mr-2" data-id="element-283">
                      {fail.title}
                    </span>
                    <span className="text-[#374151]" data-id="element-284">{fail.desc}</span>
                  </div>
                </div>)}
            </div>

            <div className="bg-[#F0FFF4] p-8 rounded-3xl border-2 border-[#10B981]/20" data-id="element-285">
              <h3 className="text-2xl font-bold text-[#1B5E20] mb-2" data-id="element-286">
                LymphoriaX™ is different.
              </h3>
              <p className="text-lg text-[#10B981] font-medium" data-id="element-287">
                Simple, gentle, and real. A daily reset — without extremes.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}